export const API_URL = window.API_CONFIG?.apiUrl || process.env.REACT_APP_API_URL || '';

// Construye la URL de una imagen servida por el backend, sin duplicar el
// dominio si la ruta ya viene absoluta (y corrigiendo el host si viene mal,
// p.ej. si quedó guardada con el dominio del frontend por error).
// Devuelve '' si no hay path (para no renderizar 'null'/'undefined' en el DOM).
export function buildBackendImgUrl(path) {
  if (!path) return '';
  if (/^data:/i.test(path)) return path;
  if (/^https?:\/\//i.test(path)) {
    try {
      const u = new URL(path);
      const api = new URL(API_URL);
      u.protocol = api.protocol;
      u.host = api.host;
      return u.toString();
    } catch {
      return path;
    }
  }
  return `${API_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}
